import { Decimal } from '@snap-types/types/decimal';
import { z } from 'zod';

import { WritableQuoteBuilderStateType } from '../../types/state';
import { buildElementId } from '../utilities/element-id';
import { buildIssueId } from '../utilities/issue-id';
import { deleteIssue, upsertIssue } from '../utilities/issue-managers';

type ValidateUnitCostParams = {
  unitCost: string | Decimal;
  quoteLineUuid: string;
  quotePriceUuid: string;
};

const validator = z.coerce
  .number({
    error: 'Unit cost is required',
  })
  .positive({ message: 'Unit price must be greater than 0' });

export function validateUnitCost(
  state: WritableQuoteBuilderStateType,
  { unitCost, quoteLineUuid, quotePriceUuid }: ValidateUnitCostParams,
) {
  const unitCostString = unitCost.toString();

  const invalidIssueId = buildIssueId({
    area: 'quotePrice',
    quoteLineUuid,
    quotePriceUuid,
    type: 'invalid',
    field: 'unitCost',
  });

  const result = validator.safeParse(unitCostString);

  if (!result.success) {
    const error = result.error.flatten().formErrors[0];

    return upsertIssue(state, invalidIssueId, {
      title: 'Invalid unit cost',
      description: error,
      severity: 'error',
      type: 'invalid',
      field: 'unitCost',
      area: 'quotePrice',
      quoteLineUuid,
      quotePriceUuid,
      action: {
        type: 'modify',
        elementId: buildElementId({
          uuid: quotePriceUuid,
          field: 'unitCost',
        }),
      },
    });
  }

  deleteIssue(state, invalidIssueId);

  return new Decimal(result.data);
}
